
//import logo from '../img/logo.png';

function convertRef(ref, value, contact) {
    var options = [];
    var label;
    var id = "";
    switch (ref) {
        case 229149: //parent id EPC BAND
            id = 229149;
            options = [{ value: "-1", name: '' }, { value: "229150", name: 'A' }, { value: "229151", name: 'B' }, { value: "229152", name: 'C' }, { value: "229153", name: 'D' }, { value: "229154", name: 'E' }, { value: "229155", name: 'F' }, { value: "229156", name: 'G' }]
            label = 'EPC Rating New Pre'
            break;
        case 230416:
            id = 230416;
            options =[{value: "-1",name:''},{value: "230417", name:'Required'},{value: "230418", name:'On Hold'},{value: "230419", name:'Completed'},{value: "230420", name:'N/A'}]
            label = 'SURVEYING / WHOLE HOUSE ASSESSMENT CHECK REQUIRED'
            break;
        case 248080:
            id =248080;
            label = 'Date of EPR+ Booking';
            break;
        case 248081:
            id =248081;
            label = 'Date of RFA Booking';
            break;
        case 229236:
            id =229236;
            label = 'Survey Date';
            break;
        case 233685: //id EPC Score
            id = 233685;
            label = 'EPC New Pre Score'
            break;
        case "InspectionDate":
        case 229279:
            id = 229279;
            label = 'EPC New PRE Date'
            break;
        case 230184:
            id = 230184;
            options =[{value:"234401",name:"Alan Smith"},{value:"230185",name:"Alessandro Tibaldi"},{value:"230191",name:"Andrew Black"},{value:"234402",name:"Andrew Porteous"},{value:"233656",name:"Ben Pitkin"},{value:"237624",name:"Ben Tame"},{value:"244386",name:"Caroline de Mancha Stevens"},{value:"244248",name:"Charlie Linthwaite"},{value:"234409",name:"Chris Mason"},{value:"233657",name:"Chris O'Halloran"},{value:"244079",name:"Conor Kane"},{value:"230186",name:"Chris O'Halloran"},{value:"233655",name:"Daniel Cotter"},{value:"244384",name:"David Raymond"},{value:"230187",name:"Gary Dunstan"},{value:"230188",name:"Gavin Herbert"},{value:"234404",name:"Henry Onabanjo"},{value:"244041",name:"Jack Ford"},{value:"234403",name:"James Money"},{value:"234400",name:"Murat Emir"},{value:"244385",name:"Nick Raymond"},{value:"230192",name:"Nick Reeves"},{value:"230189",name:"Ryan Hayward"},{value:"230193",name:"Sam Fuljames"},{value:"234399",name:"Saul Whitmore"},{value:"239560",name:"Simon Howes"},{value:"239559",name:"Stuart Pound"},{value:"241094",name:"Sue Poole"},{value:"230190",name:"Ying Man"}]
            label = 'EPC New Pre DEA'
            break;
        case 229174:
            id = 229174;
            label = 'EPC New RRN'
            break;
        case 245860:
            id = 245860;
            label = 'EPC Pre New Data File'
            break;
        case "Rooms":
        case 244045:
            id = 244045;
            options = [{ value: "-1", name: '' }, { value: "244046", name: '1' }, { value: "244047", name: '2' }, { value: "244048", name: '3' }, { value: "244049", name: '4' },
            { value: "244050", name: '5' }, { value: "244051", name: '6' }, { value: "244052", name: '7' }, { value: "244053", name: '8' }, { value: "244054", name: '9' }, { value: "244055", name: '10' }]
            label = 'Number of Habitable Rooms'
            break;
        case "FloorArea":
        case 245792:
            id = 245792;
            label = 'EPC New Pre Floor Area'
            break;
        case "FloorAreaBand":
        case 245855:
            id = 245855;
            options = [{ value: "-1", name: '' }, { value: "245856", name: '0-72m2' }, { value: "245857", name: '73m2-97m2' }, { value: "245858", name: '98m2-199m2' }, { value: "245859", name: '200m2+' }]
            label = 'EPC Pre New Floor Area Band'
            break;
        case 229160:
            id = 229160;
            label = 'EPC New Pre CO2 Tonnes'
            break;
        case 229157:
            id = 229157;
            label = 'EPC New 3 Yr Energy Costs';
            break;
        case "PropertyDetachment":
        case 239141:
            id = 239141;
            options = [{ value: "-1", name: '' }, { value: "239142", name: "Detached" }, { value: "239143", name: "Semi-detached" }, { value: "239144", name: "Mid-terrace" }, { value: "239145", name: "End-Terrace" }, { value: "239146", name: "N/A - Flat or Maisonette" }]
            label = 'EPC New Pre - Property Detachment'
            break;
        case "BuildForm":
        case 239147:
            id = 239147;
            options = [{ value: "-1", name: '' }, { value: "239148", name: "House" }, { value: "239149", name: "Bungalow" }, { value: "239150", name: "Flat" }, { value: "239151", name: "Maisonette" }]
            label = 'EPC New Pre - Built Form'
            break;
        case "FloorLocation":
        case 239152:
            id = 239152;
            options = [{ value: "-1", name: '' }, { value: "239153", name: "Basement" }, { value: "239154", name: "Ground-floor" }, { value: "239155", name: "Mid-floor" }, { value: "239156", name: "Top-floor" }, { value: "239157", name: "N/A - (house / bungalow)" }]
            label = 'EPC New Pre - Position (Flats / Maisonettes)'
            break;
        case "ExternalWallType":
        case 239158:
            id = 239158;
            options = [{ value: "-1", name: '' }, { value: "239159", name: "Granite or Whinstone" }, { value: "239160", name: "Sandstone or Limestone" }, { value: "239161", name: "Solid Brick" }, { value: "239162", name: "Cob" }, { value: "239163", name: "Cavity Wall" }, { value: "239164", name: "Timber Frame" }, { value: "239165", name: "Park Home" }, { value: "239166", name: "System Built" }]
            label = 'EPC New Pre - Wall Type'
            break;
        case "ExternalWallInsulation":
        case 239166:
            id = 239166;
            options = [{ value: "-1", name: '' }, { value: "239167", name: "as built, no insulation (assumed)" }, { value: "239168", name: "as built, partial insulation (assumed)" }, { value: "239169", name: "as built, insulated (assumed)" }, { value: "239170", name: "with internal insulation" }, { value: "239171", name: "with external insulation" }, { value: "239172", name: "filled cavity" }, { value: "239173", name: "filled cavity with internal insulation" }, { value: "239174", name: "filled cavity with external insulation" }, { value: "239175", name: "with additional insulation" }]
            label = 'EPC New Pre - Wall Insulation'
            break;
        case 239176:
            id = 239176;
            options = [{ value: "-1", name: '' }, { value: "239177", name: "Granite or Whinstone" }, { value: "239178", name: "Sandstone or Limestone" }, { value: "239179", name: "Solid Brick" }, { value: "239180", name: "System Built" }, { value: "239181", name: "Cob" }, { value: "239182", name: "Cavity Wall" }, { value: "239183", name: "Timber Frame" }, { value: "239184", name: "Park Home" }]
            label = 'EPC New Pre - Secondary Wall Type'
            break;
        case 239185:
            id = 239185;
            options = [{ value: "-1", name: '' }, { value: "239186", name: "as built, no insulation (assumed)" }, { value: "239187", name: "as built, partial insulation (assumed)" }, { value: "239188", name: "as built, insulated (assumed)" }, { value: "239189", name: "with internal insulation" }, { value: "239190", name: "with external insulation" }, { value: "239191", name: "as built" }, { value: "239192", name: "filled cavity" }, { value: "239193", name: "filled cavity with internal insulation" }, { value: "239194", name: "filled cavity with external insulation" }, { value: "239195", name: "with additional insulation" }]
            label = 'EPC New Pre - Secondary Wall Insulation'
            break;
        case "Roof":
        case 239217:
            id = 239217;
            options = [{ value: "-1", name: '' }, { value: "239218", name: "Pitched" }, { value: "239219", name: "Pitched (vaulted / sloping ceiling)" }, { value: "239220", name: "Flat" }, { value: "239221", name: "Roof Room (s)" }, { value: "239222", name: "Thatched" }, { value: "239223", name: "Another Dwelling Above" }, { value: "239224", name: "Roof Room (s)" }]
            label = 'EPC New Pre - Roof Type'
            break;
        case "RoofInsulation":
        case 239196:
            id = 239196;
            options = [{ value: "-1", name: '' }, { value: "239197", name: "no insulation" }, { value: "239198", name: "XX mm Loft Insulation (complete mm field)" }, { value: "239199", name: "insulated at rafters" }, { value: "239200", name: "no insulation (assumed)" }, { value: "239201", name: "limited insulation (assumed)" }, { value: "239202", name: "insulated (assumed)" }, { value: "239203", name: "limited insulation" }, { value: "239204", name: "insulated" }, { value: "239205", name: "ceiling insulated" }, { value: "239206", name: "thatched" }, { value: "239207", name: "thatched with additional insulation" }]
            label = 'EPC New Pre - Roof Insulation'
            break;
        case "RoofInsulationMM":
        case 239208:
            id = 239208;
            options = [{ value: "-1", name: '' }, { value: "239209", name: "<= 50 mm" }, { value: "239210", name: "<= 75 mm" }, { value: "239211", name: "<= 100 mm" }, { value: "239212", name: "<= 150 mm" }, { value: "239213", name: "<= 175 mm" }, { value: "239214", name: "<= 200 mm" }, { value: "239215", name: "<= 250 mm" }, { value: "239216", name: "<=270 mm" }, { value: "239217", name: "<= 300 mm" }, { value: "239218", name: "> 300 mm" }]
            label = 'EPC New Pre - Loft Insulation mm'
            break;
        case 239224:
            id = 239224;
            options = [{ value: "-1", name: '' }, { value: "239225", name: "Pitched" }, { value: "239226", name: "Pitched (vaulted / sloping ceiling)" }, { value: "239227", name: "Flat" }, { value: "239228", name: "Roof Room (s)" }, { value: "239229", name: "Thatched" }, { value: "239230", name: "Another Dwelling Above" }, { value: "239231", name: "Roof Room (s)" }]
            label = 'EPC New Pre - Secondary Roof Type'
            break;
        case 239231:
            id = 239231;
            options = [{ value: "-1", name: '' }, { value: "239232", name: "no insulation" }, { value: "239233", name: "XX mm Loft Insulation (complete mm field)" }, { value: "239234", name: "insulated at rafters" }, { value: "239235", name: "no insulation (assumed)" }, { value: "239236", name: "limited insulation (assumed)" }, { value: "239237", name: "insulated (assumed)" }, { value: "239238", name: "limited insulation" }, { value: "239239", name: "insulated" }, { value: "239240", name: "ceiling insulated" }, { value: "239241", name: "thatched" }, { value: "239242", name: "thatched with additional insulation" }, { value: "239243", name: "with additional insulation" }]
            label = 'EPC New Pre - Secondary Roof Insulation'
            break;
        case 239244:
            id = 239244;
            options = [{ value: "-1", name: '' }, { value: "239245", name: "<= 50 mm" }, { value: "239246", name: "<= 75 mm" }, { value: "239247", name: "<= 100 mm" }, { value: "239248", name: "<= 150 mm" }, { value: "239249", name: "<= 175 mm" }, { value: "239250", name: "<= 200 mm" }, { value: "239251", name: "<= 250 mm" }, { value: "239252", name: "<= 300 mm" }, { value: "239253", name: "> 300 mm" }]
            label = 'EPC New Pre - Secondary Loft Insulation mm'
            break;
        case "FloorType":
        case 239253:
            id = 239253;
            options = [{ value: "-1", name: '' }, { value: "239254", name: "Suspended" }, { value: "239255", name: "Solid" }, { value: "239256", name: "To unheated space" }, { value: "239257", name: "To external air" }, { value: "239258", name: "Another dwelling below" }, { value: "239259", name: "Another premises below" }]
            label = 'EPC New Pre - Floor Type'
            break;
        case "FloorInsulation":
        case 239267:
            id = 239267;
            options = [{ value: "-1", name: '' }, { value: "239268", name: "no insulation (assumed)" }, { value: "239269", name: "limited insulation (assumed)" }, { value: "239270", name: "insulated (assumed)" }, { value: "239271", name: "insulated" }]
            label = 'EPC New Pre - Floor Insulation'
            break;
        case 239260:
            id = 239260;
            options = [{ value: "-1", name: '' }, { value: "239261", name: "Suspended" }, { value: "239262", name: "Solid" }, { value: "239263", name: "To unheated space" }, { value: "239264", name: "To external air" }, { value: "239265", name: "Another dwelling below" }, { value: "239266", name: "Other premises below" }]
            label = 'EPC New Pre - Secondary Floor Type'
            break;
        case 239272:
            id = 239272;
            options = [{ value: "-1", name: '' }, { value: "239273", name: "no insulation (assumed)" }, { value: "239274", name: "limited insulation (assumed)" }, { value: "239275", name: "insulated (assumed)" }, { value: "239276", name: "insulated" }]
            label = 'EPC New Pre - Secondary Floor Insulation'
            break;
        case "Glazing":
        case 239283:
            id = 239283;
            options = [{ value: "-1", name: '' }, { value: "239284", name: "Single glazed" }, { value: "239285", name: "Some double glazing" }, { value: "239286", name: "Some triple glazing" }, { value: "239287", name: "Some secondary glazing" }, { value: "239288", name: "Some multiple glazing" }, { value: "239289", name: "Partial double glazing" }, { value: "239290", name: "Partial triple glazing" }, { value: "239291", name: "Partial secondary glazing" }, { value: "239292", name: "Partial multiple glazing" }, { value: "239293", name: "Mostly double glazing" }, { value: "239294", name: "Mostly triple glazing" }, { value: "239295", name: "Mostly secondary glazing" }, { value: "239296", name: "Mostly multiple glazing" }, { value: "239297", name: "Fully double glazed" }, { value: "239298", name: "Fully Triple Glazed" }, { value: "239299", name: "Full secondary glazing" }, { value: "239300", name: "Multiple glazing throughout" }, { value: "239301", name: "High performance glazing" }]
            label = 'EPC New Pre - Windows Description'
            break;
        case "GlazingAmount":
        case 239277:
            id = 239277;
            options = [{ value: "-1", name: '' }, { value: "239278", name: "0 - single glazed" }, { value: "239279", name: "1 to 30" }, { value: "239280", name: "31 to 79" }, { value: "239281", name: "80 to 99" }, { value: "239282", name: "100" }]
            label = 'EPC New Pre - Windows % Multi Glazed'
            break;
        case "MainHeating":
        case 239312:
            id = 239312;
            options = [{ value: "-1", name: '' }, { value: "239313", name: "None (electric heaters assumed)" }, { value: "239314", name: "Boiler (radiators and / or underfloor)" }, { value: "239315", name: "Micro-cogen" }, { value: "239316", name: "Heat Pump (west system)" }, { value: "239317", name: "Warm Air Heat Pump" }, { value: "239318", name: "Warm Air (not heat pump)" }, { value: "239319", name: "Community Heating" }, { value: "239320", name: "Electric Storage" }, { value: "239321", name: "Electric Underfloor" }, { value: "239322", name: "Room Heaters" }, { value: "239323", name: "Electric Ceiling" }, { value: "239324", name: "Air Source Heat Pump" }]
            label = 'EPC New Pre - Main Heating System'
            break;
        case "MainHeatingType":
        case 239324:
            id = 239324;
            options = [{ value: "-1", name: '' }, { value: "239325", name: "Boiler and radiators" }, { value: "239326", name: "Boiler and underfloor heating" }, { value: "239327", name: "Micro-cogeneration" }, { value: "239328", name: "GSHP with radiators" }, { value: "239329", name: "WSHP with radiators" }, { value: "239330", name: "ASHP with radiators" }, { value: "239331", name: "SAHP with radiators (solar assisted)" }, { value: "239332", name: "GSHP with fan coil units" }, { value: "239333", name: "WSHP with fan coil units" }, { value: "239334", name: "ASHP with fan coil units" }, { value: "239335", name: "SAHP with fan coil units" }, { value: "239336", name: "GSHP underfloor" }, { value: "239337", name: "WSHP underfloor" }, { value: "239338", name: "ASHP underfloor" }, { value: "239339", name: "SAHP underfloor" }, { value: "239340", name: "GSHP Warm air" }, { value: "239341", name: "WSHP Warm air" }, { value: "239342", name: "ASHP Warm air" }, { value: "239343", name: "Warm air" }, { value: "239344", name: "Community scheme" }, { value: "239345", name: "Electric Storage Heaters" }, { value: "239346", name: "Electric Underfloor heating" }, { value: "239347", name: "Room heaters" }, { value: "239348", name: "Electric ceiling heating" }]
            label = 'EPC New Pre - Heating Type'
            break;
        case "MainHeatingFuel":
        case 239349:
            id = 239349;
            options = [{ value: "-1", name: '' }, { value: "239350", name: "Mains Gas" }, { value: "239351", name: "LPG" }, { value: "239352", name: "Oil" }, { value: "239353", name: "B30K" }, { value: "239354", name: "Liquid Biofuel" }, { value: "239355", name: "Coal" }, { value: "239356", name: "Smokeless Fuel" }, { value: "239357", name: "Anthracite" }, { value: "239358", name: "Duel Fuel (mineral and wood)" }, { value: "239359", name: "Wood logs" }, { value: "239360", name: "Wood pellets" }, { value: "239361", name: "Wood chips" }, { value: "239362", name: "Electric" }, { value: "239363", name: "Electricaire" }]
            label = 'EPC New Pre - Heating Fuel'
            break;
        case "MainHeatingControls":
        case 239384:
            id = 239384;
            options = [{ value: "-1", name: '' }, { value: "239413", name: "Appliance thermostats" }, { value: "239410", name: "Automatic charge control" }, { value: "239411", name: "Celect controls" }, { value: "239408", name: "Charging system linked to use of community heating, programmer and at least two thermostats" }, { value: "239405", name: "Charging system linked to use of community heating, programmer 3 and room thermostat" }, { value: "239407", name: "Charging system linked to use of community heating, programmer and TRVs" }, { value: "239404", name: "Charging system linked to use of community heating, room 2 thermostat only" }, { value: "239406", name: "Charging system linked to use of community heating, TRVs" }, { value: "239412", name: "Controls for high heat retention storage heaters" }, { value: "239397", name: "Flat rate charging, no thermostatic control of room temperature" }, { value: "239403", name: "Flat rate charging, programmer and at least two room thermostats" }, { value: "239400", name: "Flat rate charging. programmer and room thermostat" }, { value: "239402", name: "Flat rate charging, programmer and TRVs" }, { value: "239398", name: "Flat rate charging, programmer, no room thermostat" }, { value: "239399", name: "Flat rate charging, room thermostat only" }, { value: "239401", name: "Flat rate charging, TRVs" }, { value: "239409", name: "Manual charge control" }, { value: "239414", name: "No thermostatic control of room temperature" }, { value: "239385", name: "No time or thermostatic control of room temperature" }, { value: "239415", name: "Programmer and appliance thermostats" }, { value: "239389", name: "Programmer and at least two room thermostats" }, { value: "239388", name: "Programmer and room thermostat" }, { value: "239417", name: "Programmer and room thermostats" }, { value: "239386", name: "Programmer, no room thermostat" }, { value: "239390", name: "Programmer, room thermostat and TRVs" }, { value: "239394", name: "Programmer, TRVs and boiler energy manager" }, { value: "239392", name: "Programmer, TRVs and bypass" }, { value: "239393", name: "Programmer, TRVs and flow switch" }, { value: "239387", name: "Room thermostat only" }, { value: "239416", name: "Room thermostats only" }, { value: "239395", name: "Time and temperature zone control" }, { value: "239391", name: "TRVs and bypass" }, { value: "239396", name: "Weather or load compensator with condensing boiler" }]
            label = 'EPC New Pre - Main Heating Controls'
            break;
        case 239364:
            id = 239364;
            options = [{ value: "-1", name: '' }, { value: "239365", name: "Portable electric heaters (assumed)" }, { value: "239366", name: "Room heaters" }, { value: "239367", name: "None" }, { value: "239368", name: "Electric Underfloor Heating" }]
            label = 'EPC New Pre - Secondary Heating'
            break;
        case "HWS":
        case 239368:
            console.log("URMMMMMMMMm")
            id = 239368;
            options = [{ value: "-1", name: '' }, { value: "239369", name: "No system present - electric immersion assumed" }, { value: "239370", name: "From main system" }, { value: "239371", name: "From secondary system" }, { value: "239372", name: "Electric immersion, off-peak" }, { value: "239373", name: "Electric immersion, standard tariff" }, { value: "239374", name: "Gas multipoint" }, { value: "239375", name: "Gas instantaneous at point of use" }, { value: "239376", name: "Electric instantaneous at point of use" }, { value: "239377", name: "Gas Boiler / circulator" }, { value: "239378", name: "Oil Boiler / circulator" }, { value: "239379", name: "Solid Fuel boiler / circulator" }, { value: "239380", name: "Gas Range Cooker" }, { value: "239381", name: "Oil Range Cooker" }, { value: "239382", name: "Solid Fuel Range Cooker" }, { value: "239383", name: "Community Scheme" }]
            label = 'EPC New Pre - Water Heating'
            break;
        case "EnergyLight":
        case 239302:
            id = 239302;
            options = [{ value: "-1", name: '' }, { value: "239303", name: "0 - No Energy Lighting" }, { value: "239304", name: "1 to 99(fill in %). - Low Energy lighting in xx% of fixed outlets" }, { value: "239305", name: "100 - Low Energy Lighting in all fixed outlets" }]
            label = 'EPC New Pre - Low Energy Lighting %'
            break;
        case "EnergyLightPer":
        case 239306:
            id = 239306;
            options = [{ value: "-1", name: '' }, { value: "239307", name: "0-9" }, { value: "239308", name: "10-24" }, { value: "239309", name: "25-44" }, { value: "239310", name: "45-69" }, { value: "239311", name: ">69" }]
            label = 'EPC New Pre - % of low energy lighting'
            break;
        case 233672:
            id = 233672;
            options =[{value:"234392",name:"Alan Smith"},{value:"233681",name:"Alessandro Tibaldi"},{value:"233677",name:"Andrew Black"},{value:"234795",name:"Andrew Porteous"},{value:"248074",name:"Anup Dey"},{value:"233674",name:"Ben Pitkin"},{value:"237622",name:"Ben Tame"},{value:"248121",name:"Callum Wall"},{value:"248078",name:"Carl Benson"},{value:"248072",name:"Carol Stewart"},{value:"244367",name:"Caroline de Mancha Stevens"},{value:"240435",name:"Charlie Linthwaite"},{value:"233676",name:"Chris Mason"},{value:"233682",name:"Chris O'Halloran"},{value:"238714",name:"Conor Kane"},{value:"233673",name:"Daniel Cotter"},{value:"248069",name:"Darren Ingram"},{value:"238715",name:"David Guy"},{value:"248070",name:"Faisal Khan"},{value:"248075",name:"Hamzah Abdullah"},{value:"234390",name:"Henry Onabanjo"},{value:"248071",name:"Ivan Ivanov"},{value:"240436",name:"Jack Ford"},{value:"235991",name:"Jack Whitehouse"},{value:"234391",name:"James Money"},{value:"233678",name:"John Smith"},{value:"248079",name:"Jordan Dimov"},{value:"234388",name:"Murat Emir"},{value:"244368",name:"Nick Raymond"},{value:"233680",name:"Nick Reeves"},{value:"248076",name:"Raj Shourie"},{value:"243631",name:"Rob McGuinness"},{value:"233683",name:"Ryan Hayward"},{value:"233679",name:"Sam Fuljames"},{value:"234389",name:"Saul Whitmore"},{value:"248115",name:"SEUK Assessor"},{value:"248073",name:"Sherrisa Stewart"},{value:"239556",name:"Simon Howes"},{value:"239555",name:"Stuart Pound"},{value:"241093",name:"Sue Poole"},{value:"248408",name:"Waqar Khan"},{value:"233675",name:"Ying Man"},{value:"248077",name:"Zaheer Hussain"}]
            label = 'RETROFIT ASSESSOR'
            break;
    
        default:
            break;
    }
    var newData = {};
    newData.options = options;
    newData.label = label;

    var ret = value;
    for (let x = 0; x < options.length; x++) {
        if (options[x].name == value) ret = options[x].value
    }



    if (contact) {
        var field_value = {
            field_id: id,
            value: ret.toString()
        };
        var ind = -1;
        if (options.length > 0) {
            field_value.field_parent_id = id
            field_value.field_id = parseInt(ret)
            ind = contact[0].field_values.findIndex(obj => obj.field_parent_id === id)
            if (ind > -1) {
                contact[0].field_values[ind].value = ret;
                contact[0].field_values[ind].field_id = parseInt(ret);
            }
        } else {
            ind = contact[0].field_values.findIndex(obj => obj.field_id === id)
            if (ind > -1) {
                contact[0].field_values[ind].value = ret.toString();
            }
        }
        if (ind == -1) {
            contact[0].field_values.push(field_value);
        }
        newData.contact = contact;
    }



    return newData

}

export function convertXml(inData, contact) {
    console.log(contact);
    var fields = [];
    var lights = 0;
    for (const [key, value] of Object.entries(inData)) {
        if (key === "Rooms") {
            contact = convertRef("Rooms", value, contact).contact;
        }
        if (key == "InspectionDate"){
            const vDate = new Date(value);
            contact = convertRef("InspectionDate", vDate.toLocaleDateString('en-UK'), contact).contact;
        }
        if (key === "BuildingParts") {
            var floorArea = 0;
            for (let x = 0; x < inData[key][0].BuildingPartRec.length; x++) {
                for (let y = 0; y < inData[key][0].BuildingPartRec[x].FloorArea[0].double.length; y++) {
                    floorArea += parseInt(inData[key][0].BuildingPartRec[x].FloorArea[0].double[y])
                }
            }
            console.log(inData[key][0].BuildingPartRec[0])
            contact = convertRef("FloorLocation", convertFloorLocation(inData[key][0].BuildingPartRec[0].FloorLocation[0]), contact).contact;
            contact = convertRef("FloorArea", floorArea, contact).contact;
            contact = convertRef("FloorAreaBand", floorAreaBandCalc(floorArea), contact).contact;
            contact = convertRef("ExternalWallType", convertWallType(inData[key][0].BuildingPartRec[0].ExternalWallType[0]), contact).contact;
            contact = convertRef("ExternalWallInsulation", convertWallInsulation(inData[key][0].BuildingPartRec[0].ExternalWallInsulation[0]), contact).contact;
            contact = convertRef("RoofInsulation", convertRoofInsulation(inData[key][0].BuildingPartRec[0].RoofInsulation[0]), contact).contact;
            contact = convertRef("Roof", convertRoofType(inData[key][0].BuildingPartRec[0].RoofConstruction[0]), contact).contact;
            contact = convertRef("RoofInsulationMM", convertRoofInsulationMM(inData[key][0].BuildingPartRec[0].RoofThickness[0]), contact).contact;
            contact = convertRef("FloorType", inData[key][0].BuildingPartRec[0].FloorConstruction[0], contact).contact;
            contact = convertRef("FloorInsulation", convertFloorInsulation(inData[key][0].BuildingPartRec[0].FloorInsulation[0]), contact).contact;
        }
        if (key === "PropertyType1") {
            contact = convertRef("BuildForm", value, contact).contact;
        }
        if (key === "PropertyType2") {
            contact = convertRef("PropertyDetachment", convertDetachment(value), contact).contact;
        }
        if (key === "GlazingType") {
            contact = convertRef("Glazing", convertGlazing(value), contact).contact;
        }
        if (key === "DoubleGlazedProportion") {
            contact = convertRef("GlazingAmount", convertGlazingAmount(value), contact).contact;
        }
        if (key === "MainHeating") {
            contact = convertRef("MainHeating", convertMainHeating(inData[key][0].MainHeatingRec[0].MHS[0]), contact).contact;
            contact = convertRef("MainHeatingType", convertMainHeatingType(inData[key][0].MainHeatingRec[0].HeatEmitterType[0]), contact).contact;
            contact = convertRef("MainHeatingFuel", convertMainHeatingFuel(inData[key][0].MainHeatingRec[0].FuelType[0]), contact).contact;
            contact = convertRef("MainHeatingControls", convertMainHeatingControls(inData[key][0].MainHeatingRec[0].MHSCtrl[0]), contact).contact;
        }
        if (key === "WHS") {
            console.log("made it")
            contact = convertRef("HWS", convertHWS(value), contact).contact;
        }

        if (key === "LightsTotal") {
            lights = parseFloat(value);
        }
        if (key === "LelLightsTotal") {
            contact = convertRef("EnergyLight", convertLight(parseFloat(value) / lights), contact).contact;
            contact = convertRef("EnergyLightPer", convertLightPerc(parseFloat(value) / lights), contact).contact;
        }

    }
    //Mains Gas

    function convertLight(ref) {
        //  console.log(ref);
        ref = ref * 100
        switch (true) {  //1 to 99(fill in %). - Low Energy lighting in xx% of fixed outlets // "0 - No Energy Lighting  // 100 - Low Energy Lighting in all fixed outlets
            case (ref > 99):
                return "100 - Low Energy Lighting in all fixed outlets";
            case (ref > 1):
                return "1 to 99(fill in %). - Low Energy lighting in xx% of fixed outlets";
            default:
                return "0 - No Energy Lighting";
        }
    }

    function convertLightPerc(ref) {
        ref = ref * 100
        switch (true) {

            // "0-9" ,"10-24" , "25-44" ,  "45-69" , ">69" 
            case (ref > 69):
                return ">69";
            case (ref > 44):
                return "45-69";
            case (ref > 24):
                return "25-44";
            case (ref > 9):
                return "10-24";
            default:
                return "0-9";
        }
    }

    function convertHWS(ref) {
        console.log(ref + "FFFFFFFFFFFFFFFFFFFFFFFFF")
        switch (ref.toString()) {
            case "HWP":
                console.log(ref + "ZZZZZZZZZZZZZZZZZZZZZZ")
                return "From main system";
            default:
                return ref;
        }
    }

    function convertMainHeatingControls(ref) {
        switch (ref) {
            case "CBF":
                return "Programmer, TRVs and bypass";
            case "CBE":
                return "Appliance thermostats"
            case "CBE":
                return "Programmer room stat and TRVs";
            case "CWC":
                return "Warm air programmer room stat";
            case "CBC":
                return "Programmer and room stat";
            case "CRA":
                return "Room heater no thermostatic control";
            case "CBF":
                return "Programmer TRVs Bypass";
            case "CBS":
                return "Room stat only";
            case "CCI":
                return "Community room stat programmer";
            case "CSA":
                return "ESH Manual";
            case "CBT":
                return "Programmer no room stat";
            case "CRD":
                return "Room heater programmer and room stat";
            case "CRB":
                return "Room heater appliance stat";
            case "CMB":
                return "Room stat only";
            case "NON":
                return "No controls";
            case "CRC":
                return "Room heater programmer and appliance stat";
            case "CSB":
                return "ESH automatic";
            case "CBV":
                return "Programmer and 2 room stats";
            case "CSD":
                return "ESH HHR";
            case "CRE":
                return "Room heater room stat only";
            case "CMC":
                return "Programmer and room stat";
            case "CBA":
                return "No time or thermostat control";
            case "CCG":
                return "Community flat rate charging TRVs";
            case "CBX":
                return "TRVs and bypass";
            case "CBH":
                return "Programmer TRVs and boiler energy manager";
            case "CMD":
                return "TTZC";
            case "CWB":
                return "Warm air room stat only";
            default:
                return ref;
        }
    }

    function convertMainHeatingFuel(ref) {
        switch (ref) {
            case "MainsGas":
                return "Mains Gas";
            default:
                return ref;
        }
    }

    function convertMainHeatingType(ref) {
        switch (ref) {
            case "Radiators":
                return "Boiler and radiators";
            default:
                return ref;
        }
    }

    function convertMainHeating(ref) {
        switch (ref) {
            case "BGW":
            case "BGB":
                return "Boiler (radiators and / or underfloor)";
            default:
                return ref;
        }
    }

    function convertGlazing(ref) {
        switch (ref.toString().substring(0, 6)) {
            case "Double":
                return "Fully double glazed";
            default:
                return ref;
        }
    }

    function convertGlazingAmount(ref) {
        switch (true) {
            case (parseInt(ref) > 99):
                return "100";
            case (parseInt(ref) > 79):
                return "80 to 99";
            case (parseInt(ref) > 30):
                return "31 to 79";
            case (parseInt(ref) > 0):
                return "1 to 30";
            default:
                return "0 - single glazed";
        }
    }

    function convertFloorInsulation(ref) {
        switch (ref) {
            case "AsBuilt":
                return "no insulation (assumed)";
            default:
                return ref;
        }
    }

    function convertRoofInsulationMM(ref) {
        switch (ref) {
            case "_50mm":
                return "<= 50 mm";
            case "_75mm":
                return "<= 75 mm";
            case "_100mm":
                return "<= 100 mm";
            case "_150mm":
                return "<= 150 mm";
            case "_200mm":
                return "<= 200 mm";
            case "_250mm":
                return "<= 250 mm";
            case "_300mm":
                return "<= 300 mm";
            default:
                return ref;
        }
    }

    function convertRoofInsulation(ref) {
        switch (ref) {
            case "Joists":
                return "XX mm Loft Insulation (complete mm field)";
            default:
                return ref;
        }
    }

    function convertRoofType(ref) {
        switch (ref.toString().substring(0, 7)) {
            case "Pitched":
                return "Pitched";
            default:
                return ref;
        }
    }

    function convertWallInsulation(ref) {
        switch (ref) {
            case "FilledCavity":
                return "filled cavity";
            default:
                return ref;
        }
    }

    function convertWallType(ref) {
        switch (ref) {
            case "Cavity":
                return "Cavity Wall";
            default:
                return ref;
        }
    }

    function convertDetachment(ref) {
        switch (ref) {
            case "Detached":
                return ref;
            case "SemiDetached":
                return "Semi-detached";
            case "MidTerrace":
                return "Mid-terrace";
            case "EndTerrace":
                return "End-terrace";
            default:
                return "N/A - Flat or Maisonette"
        }
    }

    function convertFloorLocation(ref) {
        switch (ref) {
            case "Basement":
                return ref
            case "GroundFloor":
                return "Ground-floor"
            case "MidFloor":
                return "Mid-floor"
            case "TopFloor":
                return "Top-floor"
            default:
                return "N/A - (house / bungaow)"
        }

    }

    function floorAreaBandCalc(floorArea) {
        var band = '0-72m2';
        switch (true) {
            case (floorArea > 199):
                band = '200m2+'
                break;
            case (floorArea > 97):
                band = '98m2-199m2'
                break;
            case (floorArea > 72):
                band = '73m2-97m2'
                break;


        }
        return band
    }

    return contact;
}



export const PreEPCRow = (props) => {

    var data = {};
    var options = [];
    var value = props.data.value;
    var label;

    var ref = props.data.field_parent_id ?? props.data.field_id ?? props.data.fieldName

    var converted = convertRef(ref);
    // console.log(props);
    data = props.data;
    options = converted.options;
    label = converted.label;

    return (
        <>
            {(options.length > 0) ?
                <div key={ref} className="row" style={{ marginTop: "10px" }}>
                    <div className="col-md-4">
                        <span className="input-label">{label}</span>
                    </div>
                    <div className="col-md-4">
                        <select disabled={props.disabled} id={ref + '*' + props.index + '*' + data.field_parent_id} className="form-select form-select-lg mb-3" onChange={props.handleOnchange} aria-label="Default select example">
                            {options.map((ops) => {
                                return <option selected={(ops.value === props.data.value)} value={ops.value}>{ops.name}</option>
                            })}
                        </select>
                    </div>
                </div>
                :
                <div key={value} className="row" style={{ marginTop: "10px" }}>
                    <div className="col-md-4">
                        <span className="input-label">{label}</span>
                    </div>
                    <div className="col-md-4">
                        <input disabled={props.disabled} id={ref + '*' + props.index} type="text" className="form-control" defaultValue={value} onChange={props.handleOnchange}></input>
                    </div>
                </div>

            }
        </>
    );
}